import { render } from "./OurTeam.vue?vue&type=template&id=c4fdb20a&scoped=true&ts=true"
import script from "./OurTeam.vue?vue&type=script&lang=ts"
export * from "./OurTeam.vue?vue&type=script&lang=ts"

import "./OurTeam.vue?vue&type=style&index=0&id=c4fdb20a&lang=scss&scoped=true"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4fdb20a"]])

export default __exports__